import { render, staticRenderFns } from "./video-screen-recording.vue?vue&type=template&id=eb289786&scoped=true"
import script from "./video-screen-recording.vue?vue&type=script&lang=js"
export * from "./video-screen-recording.vue?vue&type=script&lang=js"
import style0 from "./video-screen-recording.vue?vue&type=style&index=0&id=eb289786&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb289786",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb289786')) {
      api.createRecord('eb289786', component.options)
    } else {
      api.reload('eb289786', component.options)
    }
    module.hot.accept("./video-screen-recording.vue?vue&type=template&id=eb289786&scoped=true", function () {
      api.rerender('eb289786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/video-screen-recording/video-screen-recording.vue"
export default component.exports